import React from 'react';

import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { getWeekdays } from '@uplift/services';


const useStyles = makeStyles()(theme => ({
  weekdays: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1),
    display: 'flex',
    width: '100%',
    userSelect: 'none',
  },
}));


export const MobileCalendarWeekdays = () => {
  const { classes } = useStyles();
  const weekdays = React.useMemo(() => {
    return getWeekdays().map(wd => wd.split('')[0]);
  }, []);

  return (
    <Box className={classes.weekdays}>
      {weekdays.map((s, i) =>
        <Box key={i} display="flex" flex="1" alignItems="center" justifyContent="center" fontWeight="500" fontSize="14px">{s}</Box>
      )}
    </Box>
  );
};
